import {createContext, useContext} from "react";
import I18nStore from "../stores/I18nStore";

export const I18nContext = createContext({} as I18nStore);
export const I18nContextProvider = I18nContext.Provider;
export const useI18nContext = () => {
    return useContext(I18nContext)
}